import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MessageBanner,
  MessageBannerType,
} from '@amzn/stencil-react-components/message-banner';
import { Button, ButtonVariant, ButtonSize } from '@amzn/stencil-react-components/button';
import { Col } from '@amzn/stencil-react-components/layout';
import { useCurrentUser } from '../auth';
import { useMessages } from '../i18n/useMessages';
import { ROUTE_PROFILE_PREFERENCES } from '../../routes';

const BUNDLE = 'shared.ui.translations.preferredLocation';
type Key = 'locationBannerMessage' | 'locationBannerAction';

/**
 * Warning banner shown on list pages when the user has no preferred
 * location configured. Renders nothing when a preferred location is set.
 */
export function PreferredLocationBanner(): React.ReactElement | null {
  const { preferredLocation } = useCurrentUser();
  const navigate = useNavigate();
  const { t } = useMessages<Key>(BUNDLE);

  if (preferredLocation) return null;

  return (
    <MessageBanner type={MessageBannerType.Warning} isDismissible={false}>
      <Col gridGap="dimensions.spacing.200">
        {t('locationBannerMessage')}
        <Button
          variant={ButtonVariant.Secondary}
          size={ButtonSize.Small}
          onClick={() => void navigate(ROUTE_PROFILE_PREFERENCES)}
        >
          {t('locationBannerAction')}
        </Button>
      </Col>
    </MessageBanner>
  );
}
